<template>
    <detail-view
      v-if="dataLoaded"
      @save="save"
      :config="config">
    </detail-view>
</template>

<script>
import fetchDetail from '@/mixins/detailViews/fetchDetail';
import saveChanges from '@/mixins/detailViews/saveChanges';
import getString from '../../../helpers/GetStrings';
import DetailView from '../../../components/detail/Detail.vue';

export default {
  components: {
    DetailView,
  },
  mixins: [fetchDetail, saveChanges],

  data() {
    return {
      module: 'whitelist',
      endpoint: 'whitelist',
      responseData: {
        single: 'whitelist',
        multiple: 'whitelists',
      },
      config: {
        module: 'whitelist',
        endpoint: 'whitelist',
        data: {
          type: 'js',
          source: '',
          comments: '',
        },
        columns: {
          left: {
            cards: [{
              title: 'Whitelisted script',
              fields: [
                {
                  name: 'type',
                  value: '',
                  label: 'Type',
                  type: 'select',
                  options: [
                    { label: 'js', value: 'js' },
                  ],
                  required: true,
                },
                {
                  name: 'source',
                  type: 'text',
                  value: '',
                  label: getString('source'),
                  required: true,
                },
                {
                  name: 'comments',
                  label: getString('comments'),
                  value: '',
                  type: 'textarea',
                },
              ],
            }],
          },
        },
      },
    };
  },
  methods: {
    save(data) {
      this.config.data = data;
      this.saveChanges();
    },

    requestParams() {
      return {
        source: this.config.data.source,
        type: this.config.data.type,
        comments: this.config.data.comments,
      };
    },
  },
};
</script>
